<h1 mat-dialog-title>JSON</h1>
<div mat-dialog-content>
    <pre *ngIf="json">{{ json }}</pre>
    <pre *ngIf="text">{{ text }}</pre>
</div>
